<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="90rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.participationTarget')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <!--content-->
        <v-card-text class="target-pop-group">
          <div class="dv-ty01">
            <div class="inner scrollbar">
              <div class="form-group col-ty">
                <div class="text-title">{{t('message.addTarget')}}</div>
                <!--form-row-->
                <div class="form-row">
                  <div class="row">
                    <div class="col">
                      <c-Input v-model="memberId" v-bind="InputName" :name="'memberId'" class="size02" @input="getDataDebounced"/>
                    </div>
                    <div class="col">
                      <Select v-model="posIdx" v-bind="selectPos"/>
                    </div>
                    <div class="col">
                      <Select v-model="deptIdx" v-bind="selectDept"/>
                    </div>
                    <div class="col">
                      <Select v-model="shiftYn" v-bind="selectShift"/>
                    </div>
                    <div class="col" v-if="targetType != 'all'">
                      <Select v-model="targetYn" v-bind="selectTarget"/>
                    </div>
                    <div class="col">
                      <Select v-model="headYn" v-bind="selectHead"/>
                    </div>
                  </div>
                </div>
                <div class="text-total">{{memberCnt}}{{t('message.selectedCount')}}</div>
              </div>
              <div class="selected-group2">
                <v-item-group selected-class="bg-active" multiple>
                  <v-container>
                    <div class="list-group">
                      <div class="list-row"
                           v-for="(item, i) in members"
                           :key="i"
                      >
                        <div class="list-txt">
                          <v-item>
                            <v-card
                              :class="item.selected?'bg-active':''"
                              dark
                              @click="onClickMemberRow(i)"
                            >
                              <div class="txt">
                                {{item.memberInfo}}
                              </div>
                            </v-card>
                          </v-item>
                        </div>
                      </div>
                    </div>
                  </v-container>
                </v-item-group>
              </div>
            </div>
            <div class="bottom-group">
              <c-btnLine01 :btnText="t('message.addSelected')" class="sm" @click="onClickAdd('s')"/>
              <c-btnLine01 :btnText="t('message.addAll')" class="sm" @click="onClickAdd('a')"/>
            </div>
          </div>
          <div class="dv-ty02">
            <div class="inner scrollbar">
              <div class="form-group col-ty">
                <div class="text-title">{{t('message.target')}}</div>
                <div class="text-total">{{targetCnt}}{{t('message.selectedCount')}}</div>
              </div>
              <div class="selected-group2">
                <v-item-group selected-class="bg-active" multiple>
                  <v-container>
                    <div class="list-group">
                      <div class="list-row"
                           v-for="(item, i) in targets"
                           :key="i"
                      >
                        <div class="list-txt">
                          <v-item v-slot="{ selectedClass, toggle }">
                            <v-card
                              :class="item.selected?'bg-active':''"
                              dark
                              @click="onClickTargetRow(i)"
                            >
                              <div class="txt">
                                {{item.memberInfo}}
                              </div>
                              <div class="txt2">
                                {{item.monitoringInfo}}
                              </div>
                            </v-card>
                          </v-item>
                        </div>
                      </div>
                    </div>
                  </v-container>
                </v-item-group>
              </div>
              <div class="bottom-group">
                <c-btn02 :btnText="t('message.removeSelected')" class="sm" @click="onClickRemove('s')"/>
                <c-btn02 :btnText="t('message.removeAll')" class="sm" @click="onClickRemove('a')"/>
              </div>
            </div>
          </div>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end pop-bottom-bg">
          <c-btn01 v-bind="btnSave" @click="handleForm"/>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import CompanyService from "@/services/company.service";
import MemberService from "@/services/member.service";
import utils from "@/common/Utils";
import _, {debounce} from 'lodash';
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const emit = defineEmits(['close', 'confirm'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const memberId = ref('')
const posIdx = ref('')
const deptIdx = ref('')
const shiftYn = ref('')
const targetYn = ref('')
const headYn = ref('')
const memberCnt = ref(0)
const members = ref([])
const targetCnt = ref(0)
const targets = ref([])
const selectDept = ref({items: [{name: t('message.department'), value: ''}]})
const selectPos = ref({items: [{name: t('message.position'), value: ''}]})
const targetType = ref('')

//ui
const btnSave = computed(() => ( {  btnText: t('message.save')} ))
const InputName = computed(() =>( {
  type: 'text',
  placeholder: t('message.name'),
} ))
const selectTarget = computed(() => ( {items: [{name: t('message.target'), value: ''},{name: 'Y', value: 'Y'},{name: 'N', value: 'N'}]} ))
const selectHead = computed(() => ( {items: [{name: t('message.organizationLeader'), value: ''},{name: 'Y', value: 'Y'},{name: 'N', value: 'N'}]} ))
const selectShift = ref( {items: [{name: t('message.shiftWork'), value: ''}]} )

//hook
onBeforeUpdate (()=>{
  members.value = []
  targets.value = []
})

onUpdated(() => {
  if(dialog.value)
    getCompanyInfo()
})

//watch
watch(posIdx, (newValue) => {
  getData()
})
watch(deptIdx, (newValue) => {
  getData()
})
watch(shiftYn, (newValue) => {
  getData()
})
watch(targetYn, (newValue) => {
  getData()
})
watch(headYn, (newValue) => {
  getData()
})
watch(members, (newValue) => {
  memberCnt.value = _.filter(members.value, {selected: true}).length
}, {deep: true})
watch(targets, (newValue) => {
  targetCnt.value = _.filter(targets.value, {selected: true}).length
}, {deep: true})

//function
const getCompanyInfo=()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    idx: companyIdx,
  }

  CompanyService.getCompany(params).then(
    (response) => {
      if(response.result){
        let posArr = {items: [{name: t('message.position'), value: ''}]}
        response.result.posList.forEach((item)=>{
          posArr.items.push({name:item.treeName, value:item.idx})
        })
        selectPos.value = posArr

        let deptArr = {items: [{name: t('message.department'), value: ''}]}
        response.result.deptList.forEach((item)=>{
          deptArr.items.push({name:item.treeName, value:item.idx})
        })
        selectDept.value = deptArr

        let shiftArr = {items: [{name: t('message.shiftWork'), value: ''}]}
        response.result.shiftList.forEach((item)=>{
          shiftArr.items.push({name:item.shiftName, value:item.idx})
        })
        selectShift.value = shiftArr
      }

      getData()
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )

  let popupType = storeRef.popupType.value
  let popupItems = storeRef.popupItems.value
  let popupItems2 = storeRef.popupItems2.value
  let moduleType = storeRef.moduleType.value ? storeRef.moduleType.value : '1'  //1:모니터링 2:리더십 없으면 기본1
  let targetArr = []
  // popupItems2는 모니터링 상세셋팅에서 전달받은 member를 노출 (popupItemsExtra에는 대상자,audit중 선택안된 리스트 들어옴)
  if(popupItems2?.length > 0){
    let memberArr = []
    popupItems2.forEach((item)=>
        memberArr.push({...item, memberInfo:`${item.memberName||t('message.noInfo')}(${item.memberId||t('message.noInfo')}) / ${item.posName||t('message.noInfo')} / ${item.deptName||t('message.noInfo')}`, selected:false})
    )
    targets.value = memberArr
  }
  else{ //popupItems1는 유저정보는없고 idx만 존재하여 서버에서 정보 읽어옴.
    _.forEach(popupItems, (val, key)=> {targetArr.push(val.idx)})

    //모니터링 대상이 없으면 불러오지 않는다
    if (targetArr.length == 0)
      return

    let params2 = {
      companyIdx: companyIdx,
      targetType: popupType, //1:참여자 2:대상자 3:audit, all:다중선택
      targetArr: targetArr,
      moduleType: moduleType
    }

    MemberService.getMemberListFilter(params2).then(
      (response) => {
        if (response.result) {
          let memberArr = []
          response.result.forEach((item)=> {
            if (popupType != 'all')
              memberArr.push({...item, memberInfo: `${item.memberName||t('message.noInfo')}(${item.memberId||t('message.noInfo')}) / ${item.posName||t('message.noInfo')} / ${item.deptName||t('message.noInfo')}`, selected: false})
            else
              memberArr.push({...item, memberInfo: `${item.memberName||t('message.noInfo')}(${item.memberId||t('message.noInfo')}) / ${item.posName||t('message.noInfo')} / ${item.deptName||t('message.noInfo')} ( +${item.monitoringCnt-1})`,selected: false})
          })
          targets.value = memberArr
        }
      },
      (error) => {
        if (error.status == 403)
          utils.movePage('/login')
        else {
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}

const getData=()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  targetType.value = storeRef.popupType.value
  let monitoringInfo:any = storeRef.monitoringInfo.value //모니터링정보
  let params = {
    companyIdx: companyIdx,
    memberId: memberId.value,
    posIdx: posIdx.value,
    deptIdx: deptIdx.value,
    shiftIdx: shiftYn.value,
    targetYn: targetYn.value,
    headYn: headYn.value,
    monitoringType: targetType.value,
    monitoringIdx: monitoringInfo.idx
  }

  MemberService.getMemberListFilter(params).then(
    (response) => {
      if(response.result){
        let memberArr = []
        response.result.forEach((item)=>{
          memberArr.push({...item, memberInfo:`${item.memberName||t('message.noInfo')}(${item.memberId||t('message.noInfo')}) / ${item.posName||t('message.noInfo')} / ${item.deptName||t('message.noInfo')}`, selected:false})
        })
        members.value = memberArr
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const handleForm=()=>{
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else{
    emit('confirm', targets.value)
  }
}

const onClickMemberRow=(i)=>{
  const selected = members.value[i].selected
  if(selected)
    members.value[i].selected = false
  else
    members.value[i].selected = true
}

const onClickTargetRow=(i)=>{
  const selected = targets.value[i].selected
  if(selected)
    targets.value[i].selected = false
  else
    targets.value[i].selected = true
}

const onClickAdd=(type)=>{
  // 대상,audit중 선택안된 반대항목
  const extraItems = storeRef.popupItemsExtra.value
  let selectedArr = null
  if(type == 's')
    selectedArr = _.filter(members.value, {selected: true})
  else if(type == 'a')
    selectedArr = members.value

  // extra 함목에 존재하면 추가불가
  const isExist = selectedArr.some(member => extraItems.some(extra => extra.idx === member.idx))
  if(isExist){
    snackText.value =  t('message.duplicatedMonitoringAuditMessage')
    snackbar.value = true
    return
  }

  _.forEach(selectedArr, (val, key)=> {
    if(!_.find(targets.value, {idx:val.idx})) {
      let newRow = {...val, memberInfo:val.memberInfo, selected:false}
      targets.value.push(newRow)
    }
  })
}

const onClickRemove=(type)=>{
  if(type == 's')
    targets.value = _.filter(targets.value, {selected: false})
  else if(type == 'a')
    targets.value = []
}

const getDataDebounced = debounce(() => {
  //if (!memberId.value || memberId.value.length < 2) return
  getData()
}, 500)

</script>


<style lang="scss">

</style>
